import styled from 'styled-components';
import IconMore from './IconMore';
var IconMoreVertical = /*#__PURE__*/styled(IconMore).withConfig({
  displayName: "IconMoreVertical",
  componentId: "c11n-8-111-1__sc-1hfgttx-0"
})(["transform:rotate(90deg);"]);
export default IconMoreVertical;